import React, { useState } from "react";
import { Outlet } from "react-router-dom";

const VesselContext = React.createContext(null);

export const useVesselContext = () => {
  return React.useContext(VesselContext);
};

function VesselDataProvider() {
  const [refreshFlag, setRefreshFlag] = useState(false);


  return (
      <VesselContext.Provider 
    value={{ 
      RefreshFlag: refreshFlag,
      SetRefreshFlag: setRefreshFlag,
    }}>
      <Outlet />
    </VesselContext.Provider>
  );
}

export default VesselDataProvider;
